import React, { useState, Suspense, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';
import { Hidden, withWidth } from '@material-ui/core';
import { isWidthUp } from '@material-ui/core/withWidth';

import { historyRef } from '~/services/history';
import * as authActions from '~/store/modules/auth/auth-actions';
import { selectEnableAIRoutingSuggestion } from '~/store/modules/configuration/configuration-selectors';

import Loading from '../../components/Loading';
import AiRouteJobWidget from '../../components/AiRouteJobWidget';
// import AuthGuard from '../../components/AuthGuard';
import { Header, Sidebar } from './components';
import { drawerWidth, AppContent, Drawer, MainContent, Root } from './styles';

type MainLayoutPropsType = {
  width: 'md' | 'xs' | 'sm' | 'lg' | 'xl';
};

const MainLayout: React.FunctionComponent<MainLayoutPropsType & RouteConfigComponentProps<any>> = ({
  route,
  width
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const dispatch = useDispatch();
  const enableAIRoutingSuggestion = useSelector(selectEnableAIRoutingSuggestion);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    dispatch(authActions.RefreshRequest());
  }, [historyRef.current?.history?.location?.pathname]);

  return (
    <Root>
      <Suspense fallback={<Loading />}>
        <Drawer>
          <Hidden xlUp implementation="js">
            <Sidebar
              PaperProps={{ style: { width: drawerWidth } }}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
            />
          </Hidden>
          <Hidden lgDown implementation="css">
            <Sidebar PaperProps={{ style: { width: drawerWidth } }} />
          </Hidden>
        </Drawer>
        <AppContent>
          <Header onDrawerToggle={handleDrawerToggle} />
          <MainContent p={isWidthUp('lg', width) ? 12 : 5}>{renderRoutes(route?.routes)}</MainContent>
          {/* <Footer /> */}
        </AppContent>
        {enableAIRoutingSuggestion && <AiRouteJobWidget />}
      </Suspense>
    </Root>
  );
};

export default withWidth()(MainLayout);
